// Public client config only. Never put service_role, OpenAI, cron, or Meta tokens here.
export const ENV = {
  SUPABASE_URL: 'https://qzmhqiwviyftoppuhkpy.supabase.co',
  SUPABASE_ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6bWhxaXd2aXlmdG9wcHVoa3B5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NTY2ODMsImV4cCI6MjA2OTUzMjY4M30.9UvmqvYFWRFoF6p7dEzl6MK_tkXEcw5hIYM7lxtdZ0I',
  WHATSAPP_SYSTEM_USER_ID: '879ce3a2-ad29-4953-996b-7d01b77d14d2',
  APP_ENQUIRY_WA_TEMPLATE: 'service_booking_update',
  APP_ENQUIRY_WA_TEMPLATE_LANG: 'en',
  APP_ENQUIRY_WA_DETAIL_TEMPLATE: '',
};

export const SUPABASE_URL = ENV.SUPABASE_URL;
export const SUPABASE_ANON_KEY = ENV.SUPABASE_ANON_KEY;
